'use client';

import { type ReactNode, createContext, useRef, type JSX } from 'react';

import type { RegexPatternsState } from '../stores/regexPatternsStore';
import { createRegexPatternsStore } from '../stores/regexPatternsStore';

export type RegexPatternsStoreApi = ReturnType<typeof createRegexPatternsStore>;

export type RegexPatternsStoreProviderProps = {
    children: ReactNode;
    regexPatternsState?: RegexPatternsState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const RegexPatternsStoreContext = createContext<RegexPatternsStoreApi | undefined>(undefined);

export function RegexPatternsStoreProvider({ children, regexPatternsState }: RegexPatternsStoreProviderProps): JSX.Element {
    const storeRef = useRef<RegexPatternsStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createRegexPatternsStore(regexPatternsState);
    }

    return <RegexPatternsStoreContext.Provider value={storeRef.current}>{children}</RegexPatternsStoreContext.Provider>;
}
